import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { PersonalApiKey } from "../../gql";

const PersonalApiKeysTableNameCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<PersonalApiKey>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{apiKey.name}</TableCellText>
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableNameCell;
